import axios from "axios"
import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { errorMessage } from "../errors"
import { API_URL, serverError } from "../util"

const useSpecialities = () => {
  const [specialities, setSpecialities] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")
  const [needRefetch, setNeedRefetch] = useState(true)

  useEffect(() => {
    const fetchSpecialities = async () => {
      setLoading(true)

      try {
        const resp = await axios.get(`${API_URL}/thesaurus/speciality/list`)
        const { status, message, specialities } = resp.data

        setLoading(false)
        if (status === "failed") return setError(errorMessage(message))

        setSpecialities(specialities)
      } catch (error) {
        setLoading(false)
        toast.error(serverError())
      }
    }

    if (needRefetch) {
      fetchSpecialities()
      setNeedRefetch(false)
    }
  }, [needRefetch])

  const refetch = () => setNeedRefetch(true)

  return { specialities, loading, error, refetch }
}

export default useSpecialities
